import React from 'react';

const TextOnlyButton = ({ children, onClick }) => (
  <button onClick={onClick} className="c-button-text-only">
    {children}
  </button>
);

export default TextOnlyButton;
